export default {
  translation: {
    appName: 'HR Attendance',
    nothingHereYet: 'No hay nada aquí aún',
    timezone: 'Zona horaria',
    attendances: {
      create: 'Crear asistencia',
      edit: 'Editar asistencia',
      enteredAt: 'Hora de entrada',
      enteredAtStamp: 'Llegada: {{enteredAt}}',
      for: 'Asistencias de {{name}}',
      leftAt: 'Hora de salida',
      leftAtStamp: 'Salida: {{leftAt}}',
      mine: 'Mis asistencias',
      registry: {
        word: 'Registro de asistencia',
        checkIn: 'Registrar entrada',
        checkOut: 'Registrar salida',
      },
      word: 'asistencias',
    },
    confirmations: {
      areYouSure: '¿Está seguro/a?',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
    organizations: {
      create: 'Crear organización',
      edit: 'Editar organización',
      name: 'Nombre',
      word: 'Organizaciones',
    },
    pagination: {
      previous: 'Anterior',
      next: 'Siguiente',
    },
    sessions: {
      logIn: 'Ingresar',
      logOut: 'Salir',
    },
    users: {
      create: 'Crear usuario',
      edit: 'Editar usuario',
      email: 'email',
      name: 'nombre',
      surname: 'apellido',
      secondSurname: 'segundo apellido',
      password: 'contraseña',
      passwordConfirmation: 'confirmación de contraseña',
      word: 'usuarios',
      list: {
        orgAdmins: 'Administradores de organización',
        employees: 'Empleados',
      },
    },
    validations: {
      email: 'no tiene el formato correcto',
      mayNotBeInTheFuture: 'No puede estar en el futuro',
      mustBeAfterEnteredAt: 'Debe ser después de la hora de entrada',
      passwordsDoNotMatch: 'La contraseña y su confirmación no coinciden',
      required: 'requerido',
      stringMax: 'no cumple con la longitud máxima',
      stringMin: 'no cumple con la longitud mínima',
    },
  },
};
